/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

export const DEFAULT_AVATAR_URL = "https://dev-vht-avatar-bucket.s3.amazonaws.com/default+avatar+block.png";

interface Props {
  src: string | null; // url to img (null if not set and should use default/preview)
  size: number; // width and height in px
  previewAvatar?: string; // preview image, if previewing a new avatar
  customStyles?: any; // custom styles
}

export function Avatar({ src, size, previewAvatar, customStyles }: Props) {
  return (
    <img
      src={previewAvatar || src || DEFAULT_AVATAR_URL}
      height={size}
      width={size}
      style={{
        borderRadius: +size / 2,
        objectFit: "cover",
        ...customStyles,
      }}
      alt=""
      onError={(e: any) => {
        e.target.onerror = null;
        e.target.src = DEFAULT_AVATAR_URL;
      }}
    />
  );
}
